var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 66,
    rx: 33,
    fill: "url(#icon_svg__a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#icon_svg__b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.1 13.2a1.1 1.1 0 0 1 1.079.884l.237 1.186a5.5 5.5 0 0 0 4.314 4.314l1.186.237a1.1 1.1 0 0 1 0 2.158l-1.186.237a5.5 5.5 0 0 0-4.314 4.314l-.237 1.186a1.1 1.1 0 0 1-2.157 0l-.238-1.186a5.5 5.5 0 0 0-4.314-4.314l-1.186-.237a1.1 1.1 0 0 1 0-2.158l1.186-.237a5.5 5.5 0 0 0 4.314-4.314l.238-1.186A1.1 1.1 0 0 1 45.1 13.2ZM29.7 19.8a1.1 1.1 0 0 1 1.062.81l.984 3.61A14.3 14.3 0 0 0 41.78 34.255l3.61.985a1.1 1.1 0 0 1 0 2.122l-3.61.985a14.3 14.3 0 0 0-10.034 10.033l-.984 3.61a1.1 1.1 0 0 1-2.123 0l-.985-3.61a14.3 14.3 0 0 0-10.033-10.033l-3.61-.985a1.1 1.1 0 0 1 0-2.122l3.61-.985a14.3 14.3 0 0 0 10.033-10.033l.985-3.61A1.1 1.1 0 0 1 29.7 19.8Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "icon_svg__a",
    x1: 83.452,
    y1: -37.4,
    x2: -6.093,
    y2: -31.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FF2CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E53FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "icon_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(6.6 6.6)",
    d: "M0 0h52.8v52.8H0z"
  })))));
};
export default SvgIcon;